import { IUser, logout, logoutOkta, MAX_INT32 } from '../common';
import { compose as lcompose } from 'lodash/fp';
import { fold } from 'fp-ts/lib/Either';
import { SetStateAction } from 'react';

export const signout =
  (setUser: (value: SetStateAction<IUser>) => void) => () =>
    logout().then(
      fold<undefined, undefined, void>(
        // TODO handle error
        console.error,
        lcompose(logoutOkta, () =>
          setUser(user => ({
            ...user,
            isAuthenticated: false,
            accessTokenExpirationDelay: MAX_INT32,
            refreshTokenReminderDelay: MAX_INT32,
          }))
        )
      )
    );
